import { elevatorIntegrationApiEnhancer } from './apiRtk/elevatorIntegrationApiEnhancer';
import elevatorIntegrationFloorMapping from './modules/my2nApi/elevatorIntegrationSlice';

const rootReducerToolkit = {
  [elevatorIntegrationApiEnhancer.reducerPath]: elevatorIntegrationApiEnhancer.reducer,
  elevatorIntegrationFloorMapping: elevatorIntegrationFloorMapping,
};

export default rootReducerToolkit;
